import { render } from "./TheScooterTypeCreationForm.vue?vue&type=template&id=cb81a946"
import script from "./TheScooterTypeCreationForm.vue?vue&type=script&lang=js"
export * from "./TheScooterTypeCreationForm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__